export default __webpack_public_path__ + "static/media/mobileBg.566d3721.png";